import React, { useReducer, useMemo, useState, useContext } from 'react';
import { Form, Icon, Header, Divider, Button, Modal, Tab } from 'semantic-ui-react';
import { maskCurrency, useSubscription } from 'utils';
import { numFormat, numParse } from '@rededompedro/utils';
import request from 'services/http';
import { tap, finalize } from 'rxjs/operators';
import { toast } from 'react-toastify';
import DragAndDropRateio from 'components/DragAndDropRateio';
import { MyContext } from './Diferencas';
import { AsyncPaginate } from 'react-select-async-paginate';


const initialFormValues = {
    excecao: '',
    funcionario: '',
    valor: '',
    parcela: 1,
    observacao: '',
    anexo: [],
}; //Valores iniciais

const formReducer = (state, action) => {
    if ('reset' in action) return initialFormValues;
    if (!('payload' in action)) return state;
    return { ...state, ...action.payload };
};

export default function RateioForm({ emp, justificativas, selectedRow, valorJustificativa }) {
    const { setSelectedRow } = useContext(MyContext);
    const [form, setForm] = useReducer(formReducer, initialFormValues);
    const [isSubmitting, setIsSubimitting] = useState(false);
    const [arrayParcelas, setArrayParcelas] = useState([]);//s
    const [valorParcela, setValorParcela] = useState();//s
    const [numeroParcela, setNumeroParcela] = useState();//s
    const [valorTotal, setValorTotal] = useState();
    const [valorTotalParcela, setValorTotalParcela] = useState('');//s
    const [salvarValorTotal, setSalvarValorTotal] = useState();//s
    const [salvarValorParcela, setSalvarParcela] = useState();//s
    const [salvarNumeroParcela, setSalvarNumeroParcela] = useState(1);//s
    const [firstOpen, setFirstOpen] = useState(false);
    const [numParcelaState, setNumParcelaState] = useState();//s
    const [botaoON, setBotaoOn] = useState(false);
    const [fileSize, setFileSize] = useState();
    const [execao, setExcecao] = useState('');
    const [listaFuncionarios, setListaFuncionarios] = useState();
    const [funcionario, setFuncionario] = useState({
        cod: '',
        name: '',
        // limite: 30000,
    });
    const [loadingButton, setLoadingButton] = useState(false)

    const moduleData$ = useMemo(
        () =>
            request({
                url: '/controladoria/apuracao-caixa/funcionarios',
                method: 'GET',
            }).pipe(
                tap(({ response }) => {
                    setListaFuncionarios(response.funcionarios);
                }),
            ),
        [],
    );
    useSubscription(moduleData$);

    // react-select-async-paginate - ultilizada para de forma assíncrona, manipular o Select de funcionários para que não comprometa o desempenho//

    const loadOptions = async (search, prevOptions) => {
        let filteredOptions;
        if (!search) {
            filteredOptions = listaFuncionarios;
        } else {
            const searchLower = search.toLowerCase();

            filteredOptions = listaFuncionarios.filter(({ label }) =>
                label.toLowerCase().includes(searchLower),
            );
        }
        const hasMore = filteredOptions.length > prevOptions.length + 5;
        const slicedOptions = filteredOptions.slice(prevOptions.length, prevOptions.length + 10);

        return {
            options: slicedOptions,
            hasMore,
        };
    };

    const StylesInputFuncionarios = {
        control: (base) => {
            return {
                ...base,
                minHeight: 0,
                maxHeight: 35,
                color: 'rgba(0, 0, 0, 0.87)',
                borderRadius: '.28571429rem',
                backGound: 'none transparent !important',
                border: '.7px solid grey !important',
                margin: '0 !important',
                boxShadow: 'none !important',
            };
        },
        option: (base) => {
            return {
                ...base,
                ':hover': {
                    backgroundColor: 'rgba(0, 0, 0, 0.18) !important',
                },
                backgroundColor: 'none !important',
                color: 'rgba(0, 0, 0, 0.95) !important',
                fontSize: '13px',
                lineHeight: '1em',
            };
        },
    };

    //Fim da configuração react-select-async-paginate //

    const inputTextObservacao = `Data do Caixa: ${selectedRow.data} , Turno: ${selectedRow.turno
        }  ,  Diferença: ${selectedRow.diferenca} , Tipo de Justificativa: ${execao} , ${funcionario.name ? 'Colaborador(a): ' + funcionario.name : ''
        }, Valor: ${form.valor} , Número de Parcela(s): ${form.parcela ? form.parcela : 1}`;

    const submitForm$ = useMemo(() => {
        const fd = new FormData();
        if (form.anexo) {
            for (const file of form.anexo) fd.append('anexo', file, file.name);
        }

        fd.append('excecao', form.excecao);
        fd.append('valor', form.valor);
        fd.append(
            'observacao',
            ['01', '04'].includes(form.excecao) ? inputTextObservacao : form.observacao,
        );
        fd.append('id_data', selectedRow.id_data);
        fd.append('empresa', emp.codDpnet);
        fd.append('parcela', form.parcela ? form.parcela : 1);
        fd.append('data', selectedRow.data);
        fd.append('turno', selectedRow.turno);
        fd.append('diferenca', selectedRow.diferenca);
        fd.append('funcionario', funcionario.cod);
        fd.append('sequencia', selectedRow.sequencia);



        return request({
            url: '/controladoria/apuracao-caixa',
            method: 'POST',
            body: fd,
        }).pipe(
            tap(({ response }) => {
                if (response) {
                    toast.success(`Justificativa adicionada com sucesso!!`, {
                        toastId: 'JustificativaSucces',
                    });
                    setSelectedRow(null);
                } else {
                    toast.error(`Houve um interno, tente novamente mais tarde!!`, {
                        toastId: 'JustificativaError',
                    });
                }
            }),
            finalize(() => {
                setIsSubimitting(false);
                setLoadingButton(false)
            }),
        );
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        form,
        selectedRow.id_data,
        emp.codDpnet,
        selectedRow.data,
        selectedRow.turno,
        selectedRow.diferenca,
        selectedRow.sequencia,
        inputTextObservacao,
    ]);

    useSubscription(submitForm$, isSubmitting);

    function removerParcelas() {
        form.parcela = 1;
        setValorTotalParcela('');
        setValorParcela();
        setNumeroParcela();
        setSalvarValorTotal();
        setSalvarNumeroParcela(1);
        setSalvarParcela()
        setNumParcelaState()
    }

    var arrayParcelasFixas = [];

    const calcularParcelaFixa = (value, numParcela) => {
        var valorParcela = Math.floor(value / numParcela);
        let valorParcelaFormatado = maskCurrency(valorParcela);

        if (valorParcela < 100) {
            arrayParcelasFixas.push({
                key: numParcela,
                text: `${numParcela} x 0${valorParcelaFormatado}`,
                value: numParcela,
            });
        } else {
            arrayParcelasFixas.push({
                key: numParcela,
                text: `${numParcela} x ${valorParcelaFormatado}`,
                value: numParcela,
            });
        }
    };

    const calcularValorTotal = (valorParcela, numParcela) => {
        setValorTotalParcela(maskCurrency(valorParcela * numParcela));
        setValorParcela(
            valorParcela < 100 ? '0' + maskCurrency(valorParcela) : maskCurrency(valorParcela),
        );
        setNumeroParcela(numParcela);
        form.parcela = numParcela;
    }; // Calcula o valor Total do valor das parcelas somadas.

    const handleChange = (event, { name, value }) => {
        if (name === 'valor') {
            value = maskCurrency(value);
            var valorTotalInput = numParse(value.replace(/[.,]/g, '')); //formata o valor digitado
            setValorTotal(valorTotalInput);

            for (let i = 1; i <= 10; i++) {
                calcularParcelaFixa(valorTotalInput, i);
            } //Chama a função que insere no array parcelas as 10 parcelas fixas.
            setArrayParcelas(arrayParcelasFixas);
            let divisaoValor = Math.floor(valorTotalInput / numParcelaState); //Recebe o valor da parcela calculado, sempre arrendondando para baixo

            calcularValorTotal(divisaoValor, numParcelaState); //  Retorna o valor total da soma das parcelas (que pode ser diferente do valor Total, caso o valor somada passe do total)
            if (valorTotalInput <= 1000 && form.parcela > 1) {
                removerParcelas()
            }
        }

        if (name === 'parcelaFixa') {
            if (valorTotal < 100) {
                return;
            } else {
                var numeroParcelaFixa = Number(value);
                setNumParcelaState(numeroParcelaFixa);
                var valorParcelaFixa = numParse(
                    arrayParcelas[value - 1].text.split('x')[1].replace(',', '.'),
                );
                calcularValorTotal(valorParcelaFixa, numeroParcelaFixa); //  Retorna o valor total da soma das parcelas (que pode ser diferente do valor Total, caso o valor somada passe do total)
            }
        }

        if (name === 'parcelaAjustavel') {
            if (valorTotal < 100) {
                return;
            } else {
                if (value <= 0 || value > 30 || value.length >= 3) {
                    setBotaoOn(true);
                    setNumeroParcela();
                    return false;
                }
                var numeroParcelaAjustevel = Number(value);
                setNumParcelaState(numeroParcelaAjustevel);
                var valorParcelaAjustavel = Math.floor(valorTotal / value);
                calcularValorTotal(valorParcelaAjustavel, numeroParcelaAjustevel);
            }
        }
        if (name === 'anexo') value = Array.from(event.currentTarget.files);

        if (name === 'excecao') {
            let filterExecao = justificativas.filter((just) => just.cod === value);
            setExcecao(filterExecao[0].descricao);
            if (value !== '04' && form.parcela > 1) {
                removerParcelas()
            }
            if (['02', '03', '07', '08', '09'].includes(value)) {
                setFuncionario({
                    cod: '',
                    name: '',
                    //limite: 30000,
                });
            }
        }

        setBotaoOn(false);
        setForm({ payload: { [name]: value } });
    };

    const handleSubmit = async () => {
        if (
            (!!!['01', '04'].includes(form.excecao) && !!!form.observacao) ||
            !!!form.excecao ||
            !!!form.anexo.length ||
            !!!form.valor ||
            (['01', '04'].includes(form.excecao) && !!!funcionario.cod)
        ) {
            toast.error('Por favor, preencha todos os campos.', {
                toastId: 'preenchaTodosCampos',
            });
        } else if (fileSize.size > 2000000) {
            toast.error('Por favor, Insira um pdf com o tamanho máximo de 2mb.', {
                toastId: 'tamanhoPDF',
            });
        } /* else if (valorTotal > funcionario.limite && ['01'].includes(form.excecao)) {
            toast.error(
                `Erro ao salvar justificativa! Valor máximo para desconto R$ ${numFormat(
                    funcionario.limite / 100,
                )}.`,
                {
                    toastId: funcionario.cod,
                },
            );
        } */ else {

            setLoadingButton(true)
            setIsSubimitting(true)

            /*  let payload = {
                 id: selectedRow.sequencia,
                 valor: form.valor,
                 diferenca: selectedRow.diferenca
             };
             await request({
                 url: '/controladoria/apuracao-caixa/validacao',
                 method: 'POST',
                 body: payload,
             })
                 .toPromise()
                 .then(({ response }) => {
                     if (response.status === 'ok') {
                        
                     } else {
                         toast.error(`Insira um valor menor ou igual a R$ ${response.valor.toFixed(2)}`, {
                             toastId: 'differenceError',
                         });
                     }
                 })
                 .catch((err) => {
                     toast.error(`Houve um erro interno!`, {
                         toastId: 'differenceError',
                     });
                 }); */
        } // Muda o valor de IsSubimitting para true - envia pro banco de dados -
    };

    const handleFileInput = (file) => {
        setFileSize(file);
        setForm({ payload: { anexo: [file].concat(...form.anexo) } });
    }; // Add anexo

    const handleFileRemove = (file) => {
        setForm({ payload: { anexo: form.anexo.filter((it) => it.name !== file.name) } });
    }; // Remove anexo

    const cancelarModalParcelas = () => {
        form.parcela = salvarNumeroParcela;
        setNumeroParcela(salvarNumeroParcela);
        setValorParcela(salvarValorParcela);
        setValorTotalParcela(salvarValorTotal);
        setFirstOpen(false);
        // volta ao valor atual dos inputs
    };

    const parcelar = () => {
        form.parcela = numeroParcela;
        setSalvarNumeroParcela(numeroParcela);
        setSalvarParcela(valorParcela);
        setSalvarValorTotal(valorTotalParcela);
        setFirstOpen(true);
        //pega o valor atual dos inputs
    };

    const blockCharacters = (evt) => {
        if (!/^[0-9]*$/.test(evt.key) && evt.key !== 'Backspace') {
            evt.preventDefault();
        }
        //Barra os caracteres que não são numeros
    };

    const validarLimiteFuncionario = (e) => {
        // let codigoFuncionario = e.value;
        // let func_limite = funcionario_excessao.filter(
        //     (e) => e.id_funcionario === codigoFuncionario,
        // );
        setFuncionario({
            cod: e.value,
            name: e.label,
            // limite: func_limite.length > 0 ? func_limite[0].limite * 100 : 30000,
        });
    };
    const panes = [
        {

            menuItem: 'Parcela Fixa',
            pane: (
                <Tab.Pane key="tab1">
                    <p>Escolha uma parcela</p>

                    <Form.Select
                        required
                        placeholder="Parcela"
                        value={form.parcela}
                        name="parcelaFixa"
                        onChange={handleChange}
                        options={arrayParcelas}
                    />

                    {numeroParcela >= 1 && (
                        <p className="mt-4">
                            {numeroParcela} x R$ {valorParcela} = R$ {valorTotalParcela}
                        </p>
                    )}
                </Tab.Pane>
            ),
        },
        {
            menuItem: 'Parcela Ajustável',
            pane: (
                <Tab.Pane key="tab2">
                    <p>Digite a quantidade de parcelas</p>

                    <Form.Input
                        onKeyDown={blockCharacters}
                        type="number"
                        placeholder="Quantidade"
                        name="parcelaAjustavel"
                        onChange={handleChange}
                        autoComplete="off"
                    />

                    {numeroParcela >= 1 && numeroParcela <= 30 ? (
                        <p className="mt-4">
                            {numeroParcela} x R$ {valorParcela} = R$ {valorTotalParcela}
                        </p>
                    ) : (
                        <p className="mt-4">Digite uma parcela entre 1 e 30!</p>
                    )}
                </Tab.Pane>
            ),
        },
    ];

    return (
        <>
            <div className="row" style={{ zIndex: 2 }}>
                <div className="col-12 col-lg-6 d-flex flex-column">
                    <div className="row mt-2">
                        <div className="col">
                            <Header as="h3">
                                <Icon.Group size="big">
                                    <Icon name="tasks" className="primary-color" />
                                </Icon.Group>
                                <Header.Content className="secondary-color">
                                    <strong>Justificativa</strong>
                                    <Header.Subheader className="primary-color">
                                        Data: {selectedRow.data} - Turno {selectedRow.turno} -
                                        Diferença: R$ {numFormat(selectedRow.diferenca)}
                                        <p> {`Valor Registrado: R$ ${valorJustificativa.total_diferenca ?
                                            numFormat(valorJustificativa.total_diferenca) : ' 0,00'}`}</p>
                                    </Header.Subheader>
                                </Header.Content>
                            </Header>
                        </div>
                    </div>

                    <div className="row flex-grow-1 ">
                        <div className="col-8 col-lg d-flex align-items-center flex-column justify-content-center mx-auto my-3">
                            <Form size="mini" className="w-75" loading={isSubmitting} noValidate>
                                <Form.Select
                                    search
                                    selectOnBlur={false}
                                    required
                                    placeholder="Escolha a exceção"
                                    label="Tipo de Justificativa"
                                    name="excecao"
                                    value={form.excecao}
                                    onChange={handleChange}
                                    options={
                                        justificativas
                                            ? justificativas.map((it) => ({
                                                text: it.descricao,
                                                value: it.cod,
                                            }))
                                            : []
                                    }
                                />
                                {/*  */}
                                {['01', '04'].includes(form.excecao) && (
                                    <div>
                                        <label>
                                            <span
                                                style={{
                                                    fontSize: '.92857143em',
                                                    fontWeight: '700',
                                                    color: 'rgba(0,0,0,0.87)',
                                                }}
                                            >
                                                Colaborador(a) <span style={{ color: 'red' }}>*</span>
                                            </span>
                                        </label>

                                        <div>
                                            <AsyncPaginate
                                                noOptionsMessage={() =>
                                                    'Nenhum(a) colaborador(a) encontrado!'
                                                }
                                                styles={StylesInputFuncionarios}
                                                placeholder="Selecione um(a) colaborador(a)"
                                                value={
                                                    !form.excecao ||
                                                        !['01', '04'].includes(form.excecao)
                                                        ? ''
                                                        : funcionario.label
                                                }
                                                loadOptions={loadOptions}
                                                onChange={validarLimiteFuncionario}
                                            />
                                        </div>
                                        {/*   {funcionario.cod &&
                                            funcionario.limite < 30000 &&
                                            ['01'].includes(form.excecao) && (
                                                <p className="mt-2 text-danger">
                                                    Limite máximo para desconto - R$
                                                    {numFormat(funcionario.limite / 100)}
                                                </p>
                                            )} */}
                                    </div>
                                )}

                                <div className="row mt-2">
                                    <div className="col-12">
                                        <Form.Input
                                            style={{ width: '140px' }}
                                            type="text"
                                            required
                                            placeholder="Informe o valor"
                                            label="Valor"
                                            value={form.valor}
                                            name="valor"
                                            onChange={handleChange}
                                            autoComplete="off"
                                        />
                                    </div>

                                    <div className="col-6 mt-4 mb-4">
                                        {['04'].includes(form.excecao) && (
                                            <div>
                                                <Button
                                                    size="small"
                                                    color="green"
                                                    onClick={() =>
                                                        valorTotal > 1000
                                                            ? parcelar()
                                                            : toast.error(
                                                                'Parcela aceita apenas em valores maiores que R$10.00.',
                                                                {
                                                                    toastId: 'Parcelar',
                                                                },
                                                            )
                                                    }
                                                >
                                                    Parcelar
                                                </Button>
                                                <Modal size="tiny" open={firstOpen}>
                                                    <Header
                                                        style={{
                                                            backgroundColor: 'white',
                                                            color: 'black',
                                                        }}
                                                    >
                                                        Parcelas
                                                    </Header>
                                                    <Modal.Content>
                                                        <Tab
                                                            panes={panes}
                                                            renderActiveOnly={false}
                                                            menu={{ secondary: true }}

                                                        />
                                                    </Modal.Content>
                                                    <Modal.Actions>
                                                        <Button onClick={cancelarModalParcelas} negative>
                                                            Cancelar
                                                        </Button>
                                                        <Button
                                                            disabled={botaoON || !valorTotalParcela}
                                                            onClick={() => setFirstOpen(false)}
                                                            positive
                                                        >
                                                            Confirmar
                                                        </Button>
                                                    </Modal.Actions>
                                                </Modal>
                                            </div>
                                        )}
                                    </div>

                                    <div className="col-6 mt-4">
                                        {numeroParcela > 1 &&
                                            ['04'].includes(form.excecao) &&
                                            valorTotal > 1000 && (
                                                <p className="mt-2">
                                                    <strong>
                                                        {numeroParcela} x R$ {valorParcela} = R${' '}
                                                        {valorTotalParcela}
                                                    </strong>
                                                </p>
                                            )}
                                    </div>

                                    <div className="col">
                                        <Form.TextArea
                                            readOnly={
                                                ['01', '04'].includes(form.excecao) ? true : false
                                            }
                                            required
                                            type="text"
                                            placeholder="Informe uma observação"
                                            label="Observação"
                                            value={
                                                ['01', '04'].includes(form.excecao)
                                                    ? inputTextObservacao
                                                    : form.observacao
                                            }
                                            name="observacao"
                                            onChange={handleChange}
                                            autoComplete="off"
                                        />
                                    </div>
                                </div>
                            </Form>
                        </div>
                    </div>
                </div>

                <Divider className="custom-divider darken d-none d-lg-block" vertical fitted />

                <div className="col d-flex flex-column">
                    <div className="row mt-2 mb-4">
                        <div className="col">
                            <Header as="h3">
                                <Icon.Group size="big">
                                    <Icon name="attach" className="primary-color" />
                                </Icon.Group>
                                <Header.Content className="primary-color">
                                    Anexo
                                    <Header.Subheader className="secondary-color">
                                        <strong>
                                            Arquivo PDF referente a justificativa
                                        </strong>
                                    </Header.Subheader>
                                </Header.Content>
                            </Header>
                        </div>
                    </div>

                    <div className="row flex-grow-1 mb-4">
                        <div className="col d-flex align-items-center flex-row justify-content-around ">
                            <DragAndDropRateio
                                height={250}
                                width={200}
                                onDrop={handleFileInput}
                                onRemove={handleFileRemove}
                            />
                        </div>
                    </div>
                </div>
            </div>

            <Divider
                className="custom-divider darken"
                fitted
                style={{ zIndex: 1, position: 'relative' }}
            />

            <div className="row flex-grow-1 mt-2">
                <div className="col">
                    <Button
                        loading={loadingButton}
                        disabled={loadingButton}
                        size="small"
                        floated="right"
                        color="green"
                        onClick={handleSubmit}
                        content={
                            <>
                                <Icon name="check" /> Salvar
                            </>
                        }
                    />
                </div>
            </div>
        </>
    );
}
